// src/DateService.ts
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import utc from 'dayjs/plugin/utc'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'

dayjs.extend(utc)
dayjs.extend(customParseFormat)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)

export const FMT = {
  time: 'HH:mm',
  onlyDate: 'DD/MM/YYYY',
  onlyDateDash: 'YYYY-MM-DD',
  date: 'DD/MM/YYYY HH:mm',
  dateDash: 'YYYY-MM-DD HH:mm',
  display: 'DD/MM/YYYY HH:mm:ss',
  dateFetch: 'YYYY-MM-DD HH:mm:ss.SSS',
  simulation: 'YYYY_MM_DD_HH_mm',
  simulationWithWind: 'MM-DD-YYYY_HH00',
  utcUnderscore: 'YYYY_MM_DD_HH_mm',
  simViento: 'YYYY-MM-DDTHH:00:00.000Z'
}

export const DayjsUnit = {
  Day: 'day',
  Week: 'week',
  Month: 'month',
  Year: 'year',
  Hour: 'hour',
  Minute: 'minute',
  Second: 'second',
  Millisecond: 'millisecond'
}

const DateService = {
  getCurrentDayJs() {
    return dayjs()
  },

  toDayjs(input, format = FMT.display) {
    if (!input) return dayjs(NaN)

    // Date nativo
    if (input instanceof Date) {
      return dayjs(input)
    }

    // Si es timestamp numérico
    if (typeof input === 'number') {
      return dayjs(input) // Dayjs sabe manejar timestamps en ms
    }

    const isIsoUtc = /T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/.test(input)
    if (isIsoUtc) {
      // Caso 1: ISO UTC de la BD
      return dayjs.utc(input).local()
    } else {
      // Caso 2: formato local de la UI
      return dayjs(input, format, true) // true = parseo estricto
    }
  },

  toString(input, format = FMT.display) {
    return input.format(format)
  },

  getMaxDate(fechaList, format = FMT.display) {
    if (!fechaList?.length) return null

    const fechasDayjs = fechaList
      .filter(Boolean)
      .map(f => this.toDayjs(f, format))
      .filter(f => f.isValid())

    if (!fechasDayjs.length) return null

    return fechasDayjs.reduce((max, current) =>
      current.valueOf() > max.valueOf() ? current : max
    )
  }
}

// Ordenar rango de fechas, la lista de fecha puede ser de dos elementos o más
export const ordenarRangoFechas = (rangoFechas, format = FMT.onlyDateDash) => {
  if (rangoFechas?.length < 1) {
    return rangoFechas
  }

  const fechasDayjs = rangoFechas.map(f => DateService.toDayjs(f, format))

  const ordenadas = fechasDayjs
    .slice()
    .sort((a, b) => a.valueOf() - b.valueOf())

  return ordenadas.map(f => f.format(format))
}

export default DateService
